import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import { useGetAllUser } from "./getAll";
import type { IUsers } from "./routeType";
import { useGetProfile } from "./me";

const { getPath } = getApi("users.post");

type IExtractedRouteType = IUsers["userSingleCreate"];

export type IPostUsers = IPickMutation<IExtractedRouteType>;

const postUser: MutationFunction<
  IPostUsers["response"],
  IPostUsers["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const usePostUser = createMutation({
  mutationFn: postUser,
  onSuccess: () => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetProfile.getKey() });
  },
});
